export const PartTitle = ({ title }: { title: string }) => {
  return <h2 className='mb-0 text-primaryColor-normal'>{title}</h2>;
};
